export function isConfigLoaded () {
  return ['FEATURES', 'LANG', 'CHANNEL', 'LOGIN_SERVICE_URL'].every(key => !!window[key])
}

export const PartialFailureNotificationDurationInMs = 30000
export const PartialFailureNotificationKey = 'partial_failure_notification'
